/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { DateRangePicker, FocusedInputShape, isInclusivelyBeforeDay } from 'react-dates';
import { ApplicationState } from 'store';
import _ from 'underscore';
import moment from 'moment';
import {
  ActivitiesTypes,
  ModalitiesTypes,
  FollowupOnlineSearchState,
  FollowupOnlineSearchTypes,
  PublicBodyTypes,
  RegionTypes,
  StatesTypes,
  SituationTypes,
  CitiesTypes,
  DateRangeTypes,
} from 'store/modules/followup_online_search_store/types';
import { States } from 'services/states';
import { Regions, RegionsStates } from 'services/regions';
import { Modalities } from 'services/modalities';
import { PublicAgencyTypes } from 'services/public_agency_types';
import { getCitiesByStates } from 'services/actions/cities_actions';
import { getFollowups } from 'store/modules/followup_store/actions';
import Select from 'react-select';
import { ProfileState } from 'store/modules/profile_store/types';
import tabId from 'services/tabId';
import { ActivitiesState } from 'store/modules/activities_store/types';
import { PanelState } from 'store/modules/panel_store/types';
import ModalLocation from 'components/atoms/modal_location';
import { Container } from './styles';

interface InnerBoundTypes {
  lat: Number | undefined;
  lng: Number | undefined;
}

interface BoundsTypes {
  ne: InnerBoundTypes;
  sw: InnerBoundTypes;
}
interface OnlineSearchFollowupFormProps {
  searchBarOpened: boolean;
  setSearchBarOpened: React.Dispatch<React.SetStateAction<boolean>>;
}

const OnlineSearchFollowupForm = (props: OnlineSearchFollowupFormProps) => {
  const { searchBarOpened, setSearchBarOpened } = props;
  interface EventDatesTypes {
    startDate: moment.Moment | null;
    endDate: moment.Moment | null;
  }

  const dispatch = useDispatch();
  const { followupOnlineSearch } = useSelector<ApplicationState, FollowupOnlineSearchState>(
    (state) => state.session.followupOnlineSearch,
  );

  const [statesList] = useState<Array<StatesTypes>>(States);
  const [modalitiesList, setModalitiesList] = useState<Array<ModalitiesTypes>>([]);
  const [publicBodyList, setPublicBodyList] = useState<Array<PublicBodyTypes>>([]);
  const [citiesList, setCitiesList] = useState<Array<CitiesTypes>>([]);
  const [citiesGeolocation, setCitiesGeolocation] = useState<Array<CitiesTypes>>([]);
  const [modalLocationOpened, setModalLocationOpened] = useState<boolean>(false);
  const [filterGeolocationType, setFilterGeolocationType] = useState<string>('estado');
  const [filterByRegion, setFilterByRegion] = useState<boolean>(false);
  const [currentFocusedIncludeDate, setCurrentFocusedIncludeDate] =
    useState<null | FocusedInputShape>(null);
  const [addressSelected, setAddressSelected] = useState<string>('');
  const [bounds, setBounds] = useState<BoundsTypes>({
    ne: { lat: 0, lng: 0 },
    sw: { lat: 0, lng: 0 },
  });
  const [position, setPosition] = useState<google.maps.LatLngLiteral | null>(null);
  const [radius, setRadius] = useState<number>(10000);

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);

  const { activities } = useSelector<ApplicationState, ActivitiesState>(
    (state) => state.storage.activities,
  );

  const onFilterChange = (
    value: string | boolean | RegionTypes | Array<any> | DateRangeTypes | SituationTypes | null,
    field: string,
  ) => {
    dispatch({ type: FollowupOnlineSearchTypes.CHANGE_VALUE, field, value });
  };

  const regionChange = (region: RegionTypes) => {
    onFilterChange(RegionsStates[region.value], 'states');

    onFilterChange(region, 'region');
  };

  const handleDateChange = (eventDates: EventDatesTypes, field: string) => {
    const newDates = {
      from: eventDates.startDate ? eventDates.startDate.format('YYYY-MM-DDTHH:mm:ss.SSSSZ') : null,
      to: eventDates.endDate ? eventDates.endDate.format('YYYY-MM-DDTHH:mm:ss.SSSSZ') : null,
    };
    onFilterChange(newDates, field);
  };

  const handleActivityChange = (activity: ActivitiesTypes) => {
    let newActivities: Array<ActivitiesTypes> = [];

    if (
      followupOnlineSearch.filters.activities.find(
        (currentActivity) => currentActivity.id === activity.id,
      )
    ) {
      newActivities = followupOnlineSearch.filters.activities.filter(
        (currentActivity) => currentActivity.id !== activity.id,
      );
    }

    if (
      !followupOnlineSearch.filters.activities.find(
        (currentActivity) => currentActivity.id === activity.id,
      )
    ) {
      newActivities = [...followupOnlineSearch.filters.activities, activity];
    }

    onFilterChange(newActivities, 'activities');
  };

  const handleAllActivities = () => {
    let newActivities = activities[profile.currentCompany[tabId()]];

    if (
      activities[profile.currentCompany[tabId()]]?.length ===
      followupOnlineSearch.filters.activities?.length
    )
      newActivities = [];

    onFilterChange(newActivities, 'activities');
  };

  const fetchFollowups = () => {
    if (profile.representant && profile.currentCompany[tabId()] !== profile.company_data.data.id) {
      dispatch(
        getFollowups(
          {
            per_page: followupOnlineSearch.postsPerPage,
            activities_list: activities[profile.currentCompany[tabId()]],
          },
          profile.currentCompany[tabId()],
        ),
      );
      return;
    }

    dispatch(
      getFollowups({
        per_page: followupOnlineSearch.postsPerPage,
        activities_list: activities[profile.currentCompany[tabId()]],
      }),
    );
  };

  useEffect(() => {
    dispatch({ type: FollowupOnlineSearchTypes.CLEAR_FILTER });
  }, [profile.currentCompany[tabId()]]);

  useEffect(() => {
    setModalitiesList(
      Modalities?.map((modality) => {
        return { label: `${modality.sigla} - ${modality.nome}`, value: modality.id };
      }),
    );
    setPublicBodyList(
      PublicAgencyTypes.filter((publicAgencyType) => publicAgencyType.id !== 6)?.map(
        (publicAgencyType) => {
          return { label: publicAgencyType.nome, value: publicAgencyType.id };
        },
      ),
    );
  }, []);

  useEffect(() => {
    (async () => {
      const statesIds = followupOnlineSearch?.filters?.states?.map((state) => state.value);
      if (statesIds?.length > 0) {
        const citiesResponse = await getCitiesByStates(statesIds);
        if (citiesResponse?.length > 0) {
          setCitiesList(
            citiesResponse?.map((city: any) => {
              return { label: `${city.name_sub} - ${city.acronym}`, value: city.id };
            }),
          );
        } else {
          setCitiesList([]);
        }
      }
      if (statesIds?.length === 0) setCitiesList([]);
    })();
  }, [followupOnlineSearch.filters.states]);

  useEffect(() => {
    if (followupOnlineSearch.filters.updated) {
      onFilterChange(!followupOnlineSearch.filters.updated, 'updated');
    }
  }, [followupOnlineSearch.filters.updated]);

  useEffect(() => {
    if (citiesGeolocation?.length === 0 || citiesGeolocation === undefined) return;

    onFilterChange(citiesGeolocation, 'cities');
  }, [citiesGeolocation]);

  const handleFilterByRegion = () => {
    setFilterByRegion(!filterByRegion);
    onFilterChange(null, 'region');
    onFilterChange([], 'cities');
    onFilterChange([], 'states');
    setCitiesList([]);
  };

  const handleFilterGeolocationType = (type: string) => {
    setFilterGeolocationType(type);
    onFilterChange(null, 'region');
    onFilterChange([], 'cities');
    onFilterChange([], 'states');
    setCitiesList([]);
  };

  const clearFilter = () => {
    dispatch({ type: FollowupOnlineSearchTypes.CLEAR_FILTER });
    setRadius(5000);
    setAddressSelected('');
    setPosition(null);
    setBounds({
      ne: { lat: 0, lng: 0 },
      sw: { lat: 0, lng: 0 },
    });
    fetchFollowups();
  };

  return (
    <Container>
      <div className="row">
        <div
          className={`col-11 mx-auto col-lg-3 col-md-12 pr-2 filter-bar shadow ${
            searchBarOpened ? '' : 'hide-bar'
          } ${
            profile.in_sample || panel?.registration_type_validation === 1 ? 'hasTopBanner' : ''
          }`}
        >
          <button
            type="button"
            onClick={() => setSearchBarOpened(!searchBarOpened)}
            className="btn btn-sm btn-link position-absolute btn-hide-search d-xxl-none"
          >
            <i className="material-icons">keyboard_arrow_right</i>
          </button>
          <div className="filter-form pr-2">
            <div className="row d-print-none">
              <div className="col-md-12">
                <div className="row m-3">
                  <div className="col-md-12 pr-2">
                    <button
                      type="button"
                      className="btn btn-sm btn-link float"
                      onClick={() => clearFilter()}
                    >
                      Limpar
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-link float-right"
                      onClick={() => fetchFollowups()}
                    >
                      Recarregar
                    </button>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="objetoSearch" className="m-0">
                      Objeto
                    </label>
                    <input
                      onKeyDown={(keyEvent) => {
                        if (keyEvent.key === 'Enter')
                          onFilterChange(!followupOnlineSearch.filters.updated, 'updated');
                      }}
                      type="text"
                      className="form-control"
                      id="objetoSearch"
                      placeholder="Pesquise por Objeto"
                      onChange={(event) => onFilterChange(event.target.value, 'object')}
                      value={followupOnlineSearch.filters.object}
                    />
                  </div>
                </div>
                <hr />
                {profile?.beta_tester && (
                  <>
                    <div className="row mb-3">
                      <div className="col-12 tour-radar">
                        <p className="mb-1">Filtrar por:</p>
                        <div className="d-flex justify-content-between">
                          <div className="form-check form-check-inline">
                            <input
                              disabled={false}
                              className="form-check-input"
                              type="radio"
                              name="pushRadioOptions"
                              id="pushRadioKeyword"
                              onChange={() => handleFilterGeolocationType('estado')}
                              checked={filterGeolocationType === 'estado'}
                            />
                            <label className="form-check-label" htmlFor="pushRadioKeyword">
                              Estado
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              disabled={false}
                              className="form-check-input"
                              type="radio"
                              name="pushRadioOptions"
                              id="pushRadioAll"
                              onChange={() => handleFilterGeolocationType('região')}
                              checked={filterGeolocationType === 'região'}
                            />
                            <label className="form-check-label" htmlFor="pushRadioAll">
                              Região
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              disabled={false}
                              className="form-check-input"
                              type="radio"
                              name="pushRadioOptions"
                              id="pushRadioLocation"
                              onChange={() => handleFilterGeolocationType('localização')}
                              checked={filterGeolocationType === 'localização'}
                            />
                            <label className="form-check-label" htmlFor="pushRadioLocation">
                              Raio de atuação
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    {filterGeolocationType === 'estado' && (
                      <>
                        <div className="row">
                          <div className="col-md-12">
                            <label htmlFor="stateSearch" className="m-0">
                              Estado
                            </label>
                            <Select
                              isMulti
                              name="StateSearch"
                              closeMenuOnSelect={false}
                              value={followupOnlineSearch.filters.states}
                              onChange={(selected) =>
                                onFilterChange(selected as Array<StatesTypes>, 'states')
                              }
                              options={statesList}
                              placeholder="Selecione os Estados"
                            />
                          </div>
                        </div>
                        <div className="d-flex justify-content-between col-md-12 p-0">
                          <div className="float-right date-template">
                            <button
                              type="button"
                              className="btn btn-sm btn-link pr-0"
                              onClick={() => {
                                onFilterChange(statesList, 'states');
                              }}
                            >
                              Todos os Estados
                            </button>
                          </div>
                        </div>

                        <div className="row mb-3">
                          <div className="col-md-12">
                            <label htmlFor="citySearch" className="m-0">
                              Cidade
                            </label>
                            <Select
                              name="CitySearch"
                              isMulti
                              closeMenuOnSelect={false}
                              value={followupOnlineSearch.filters.cities || ''}
                              onChange={(selected) =>
                                onFilterChange(selected as Array<CitiesTypes>, 'cities')
                              }
                              options={citiesList}
                              noOptionsMessage={() => 'Selecione uma cidade'}
                              placeholder="Selecione as Cidades"
                            />
                          </div>
                        </div>
                      </>
                    )}
                    {filterGeolocationType === 'região' && (
                      <div className="row">
                        <div className="col-md-12">
                          <label htmlFor="RegionSearch" className="m-0">
                            Região
                          </label>
                          <div>
                            <Select
                              name="RegionSearch"
                              value={followupOnlineSearch.filters.region || ''}
                              onChange={(selected) => {
                                regionChange(selected as RegionTypes);
                              }}
                              options={Regions}
                              placeholder="Selecione uma Região"
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {filterGeolocationType === 'localização' && (
                      <div className="row">
                        <div className="col-md-12">
                          {addressSelected !== '' && (
                            <div className="alert alert-secondary">{`${
                              radius / 1000
                            } km de ${addressSelected}`}</div>
                          )}
                          <button
                            type="button"
                            className="btn btn-link m-0 p-0 btn-block mt-2"
                            onClick={() => {
                              setModalLocationOpened(true);
                            }}
                          >
                            {addressSelected === '' ? 'Buscar Endereço' : 'Editar Endereço'}
                          </button>
                        </div>
                      </div>
                    )}{' '}
                  </>
                )}
                {!profile?.beta_tester && (
                  <>
                    {!filterByRegion && (
                      <>
                        <div className="row">
                          <div className="col-md-12">
                            <label htmlFor="stateSearch" className="m-0">
                              Estado
                            </label>
                            <Select
                              isMulti
                              name="StateSearch"
                              closeMenuOnSelect={false}
                              value={followupOnlineSearch.filters.states}
                              onChange={(selected) =>
                                onFilterChange(selected as Array<StatesTypes>, 'states')
                              }
                              options={statesList}
                              placeholder="Selecione os Estados"
                            />
                          </div>
                        </div>
                        <div className="d-flex justify-content-between col-md-12 p-0">
                          <div className="left date-template">
                            <button
                              type="button"
                              className="btn btn-sm btn-link pl-0"
                              onClick={() => handleFilterByRegion()}
                            >
                              Filtrar por Região
                            </button>
                          </div>
                          <div className="float-right date-template">
                            <button
                              type="button"
                              className="btn btn-sm btn-link pr-0"
                              onClick={() => {
                                onFilterChange(statesList, 'states');
                              }}
                            >
                              Todos os Estados
                            </button>
                          </div>
                        </div>

                        <div className="row mb-3">
                          <div className="col-md-12">
                            <label htmlFor="citySearch" className="m-0">
                              Cidade
                            </label>
                            <Select
                              name="CitySearch"
                              isMulti
                              closeMenuOnSelect={false}
                              value={followupOnlineSearch.filters.cities || ''}
                              onChange={(selected) =>
                                onFilterChange(selected as Array<CitiesTypes>, 'cities')
                              }
                              options={citiesList}
                              noOptionsMessage={() => 'Selecione uma cidade'}
                              placeholder="Selecione as Cidades"
                            />
                          </div>
                        </div>
                      </>
                    )}
                    {filterByRegion && (
                      <>
                        <div className="row">
                          <div className="col-md-12">
                            <label htmlFor="RegionSearch" className="m-0">
                              Região
                            </label>
                            <div>
                              <Select
                                name="RegionSearch"
                                value={followupOnlineSearch.filters.region || ''}
                                onChange={(selected) => {
                                  regionChange(selected as RegionTypes);
                                }}
                                options={Regions}
                                placeholder="Selecione uma Região"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="left date-template">
                          <button
                            type="button"
                            className="btn btn-sm btn-link pl-0"
                            onClick={() => handleFilterByRegion()}
                          >
                            Filtrar por Estado
                          </button>
                        </div>
                      </>
                    )}
                  </>
                )}
                <hr />
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="idSearch" className="m-0">
                      Nº Conlicitação
                    </label>
                    <input
                      onKeyDown={(keyEvent) => {
                        if (keyEvent.key === 'Enter')
                          onFilterChange(!followupOnlineSearch.filters.updated, 'updated');
                      }}
                      type="text"
                      id="idSearch"
                      className="form-control"
                      placeholder="Pesquise por Nº Conlicitação"
                      value={followupOnlineSearch.filters.id}
                      onChange={(event) => onFilterChange(event.target.value, 'id')}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="summarySearch" className="m-0">
                      Síntese
                    </label>
                    <input
                      onKeyDown={(keyEvent) => {
                        if (keyEvent.key === 'Enter')
                          onFilterChange(!followupOnlineSearch.filters.updated, 'updated');
                      }}
                      type="text"
                      id="summarySearch"
                      className="form-control"
                      placeholder="Síntese"
                      value={followupOnlineSearch.filters.summary}
                      onChange={(event) => onFilterChange(event.target.value, 'summary')}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="processNumberSearch" className="m-0">
                      Nº Processo
                    </label>
                    <input
                      onKeyDown={(keyEvent) => {
                        if (keyEvent.key === 'Enter')
                          onFilterChange(!followupOnlineSearch.filters.updated, 'updated');
                      }}
                      type="text"
                      className="form-control"
                      id="processNumberSearch"
                      placeholder="Pesquise por Nº Processo"
                      value={followupOnlineSearch.filters.processNumber}
                      onChange={(event) => onFilterChange(event.target.value, 'processNumber')}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="OrgaoSearch" className="m-0">
                      Pesquise por Órgão
                    </label>
                    <input
                      onKeyDown={(keyEvent) => {
                        if (keyEvent.key === 'Enter')
                          onFilterChange(!followupOnlineSearch.filters.updated, 'updated');
                      }}
                      type="text"
                      className="form-control"
                      id="OrgaoSearch"
                      placeholder="Pesquise por Órgão"
                      value={followupOnlineSearch.filters.publicBody}
                      onChange={(event) => onFilterChange(event.target.value, 'publicBody')}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label className="m-0">Esfera</label>
                    <Select
                      isMulti
                      name="PublicBodyTypesSearch"
                      closeMenuOnSelect={false}
                      value={followupOnlineSearch.filters.publicBodyTypes}
                      onChange={(selected) =>
                        onFilterChange(selected as Array<PublicBodyTypes>, 'publicBodyTypes')
                      }
                      options={publicBodyList}
                      placeholder="Todas as esferas"
                    />
                  </div>
                </div>
                <hr />
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="editalSearch" className="m-0">
                      Nº Edital
                    </label>
                    <input
                      onKeyDown={(keyEvent) => {
                        if (keyEvent.key === 'Enter')
                          onFilterChange(!followupOnlineSearch.filters.updated, 'updated');
                      }}
                      type="text"
                      id="editalSearch"
                      className="form-control"
                      placeholder="Pesquise por Nº Edital"
                      value={followupOnlineSearch.filters.noticeNumber}
                      onChange={(event) => onFilterChange(event.target.value, 'noticeNumber')}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <label htmlFor="modalitiesSearch" className="m-0">
                      Modalidades
                    </label>

                    <Select
                      name="modalitiesSearch"
                      isMulti
                      closeMenuOnSelect={false}
                      value={followupOnlineSearch.filters.modalities}
                      onChange={(selected) =>
                        onFilterChange(selected as Array<ModalitiesTypes>, 'modalities')
                      }
                      options={modalitiesList}
                      placeholder="Selecione as Modalidades"
                    />
                    <div className="float-right date-template">
                      <button
                        type="button"
                        className="btn btn-sm btn-link"
                        onClick={() => onFilterChange(modalitiesList, 'modalities')}
                      >
                        Todas as Modalidades
                      </button>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row mb-3">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-12">
                        <label>Data de Publicação</label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <DateRangePicker
                          startDate={
                            _.isNull(followupOnlineSearch.filters.includeDateRange.from)
                              ? null
                              : moment(followupOnlineSearch.filters.includeDateRange.from)
                          }
                          startDateId="includeDateRange_start_date_id"
                          minimumNights={0}
                          endDate={
                            _.isNull(followupOnlineSearch.filters.includeDateRange.to)
                              ? null
                              : moment(followupOnlineSearch.filters.includeDateRange.to)
                          }
                          endDateId="includeDateRange_end_date_id"
                          onDatesChange={(eventDates) =>
                            handleDateChange(eventDates, 'includeDateRange')
                          }
                          focusedInput={currentFocusedIncludeDate}
                          onFocusChange={(focusedIncludeDateRange) => {
                            setCurrentFocusedIncludeDate(focusedIncludeDateRange);
                          }}
                          startDatePlaceholderText="De"
                          endDatePlaceholderText="Até"
                          hideKeyboardShortcutsPanel
                          displayFormat="DD/MM/YYYY"
                          isOutsideRange={(day) => !isInclusivelyBeforeDay(day, moment())}
                          showClearDates
                          small
                          numberOfMonths={1}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-4 mt-1 date-template">
                        <a
                          href="#"
                          onClick={() => {
                            const newDate = {
                              from: moment().format('YYYY-MM-DDTHH:mm:ss.SSSSZ'),
                              to: moment().format('YYYY-MM-DDTHH:mm:ss.SSSSZ'),
                            };
                            onFilterChange(newDate, 'includeDateRange');
                          }}
                          className="mr-2"
                        >
                          hoje
                        </a>
                        <a
                          href="#"
                          onClick={() => {
                            const newDate = {
                              from: moment()
                                .subtract(1, 'days')
                                .format('YYYY-MM-DDTHH:mm:ss.SSSSZ'),
                              to: moment().subtract(1, 'days').format('YYYY-MM-DDTHH:mm:ss.SSSSZ'),
                            };
                            onFilterChange(newDate, 'includeDateRange');
                          }}
                        >
                          ontem
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label className="d-flex justify-content-between">
                      Atividades
                      <button
                        type="button"
                        key="activities_0"
                        className="btn btn-link p-0 btn-sm"
                        onClick={() => handleAllActivities()}
                      >
                        {followupOnlineSearch.filters.activities?.length ===
                        activities[profile.currentCompany[tabId()]]?.length
                          ? 'Nenhuma Atividade'
                          : 'Todas as Atividades'}
                      </button>
                    </label>

                    {activities[profile.currentCompany[tabId()]]?.map((activity) => (
                      <div key={`activities_${activity.codigo}`} className="form-check">
                        <input
                          onKeyDown={(keyEvent) => {
                            if (keyEvent.key === 'Enter')
                              onFilterChange(!followupOnlineSearch.filters.updated, 'updated');
                          }}
                          checked={
                            !!followupOnlineSearch.filters.activities.find(
                              (currentActivity) => currentActivity.id === activity.id,
                            )
                          }
                          className="form-check-input"
                          type="checkbox"
                          id={`activities_${activity.codigo}`}
                          onChange={() => handleActivityChange(activity)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`activities_${activity.codigo}`}
                        >
                          {activity.nome}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
                <hr />
              </div>
            </div>
          </div>

          <div className="col-12 col-md-3 px-2 py-3 filter-button d-print-none">
            <button
              type="button"
              className="btn btn-primary w-100"
              onClick={() => onFilterChange(!followupOnlineSearch.filters.updated, 'updated')}
            >
              Pesquisar
            </button>
          </div>
        </div>
      </div>
      <ModalLocation
        modalLocationOpened={modalLocationOpened}
        setModalLocationOpened={setModalLocationOpened}
        setAddressSelected={setAddressSelected}
        addressSelected={addressSelected}
        bounds={bounds}
        setBounds={setBounds}
        position={position}
        setPosition={setPosition}
        radius={radius}
        setRadius={setRadius}
        setCitiesGeolocation={setCitiesGeolocation}
      />
    </Container>
  );
};

export default OnlineSearchFollowupForm;
